import React from "react";
import { createPortal } from "react-dom";

export default function SleekSignOutDialog({ isOpen, onClose, onConfirm }) {
  if (!isOpen) return null;

  const handleConfirm = () => {
    onConfirm?.();
    onClose?.();
  };

  return createPortal(
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/40 p-4">
      <div className="w-full max-w-md rounded-2xl border border-slate-200 bg-white p-6 shadow-xl">
        <h3 className="text-lg font-semibold text-slate-900">Sign out</h3>
        <p className="mt-2 text-sm text-slate-600">
          Are you sure you want to sign out? You will need to sign in again to access your account.
        </p>
        <div className="mt-5 flex justify-end gap-3">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 rounded-lg border bg-white hover:bg-gray-50 text-sm font-semibold"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleConfirm}
            className="px-4 py-2 rounded-lg bg-sky-600 text-white hover:bg-sky-700 text-sm font-semibold"
          >
            Sign out
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}
